/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { AppBar, makeStyles } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import SaveIcon from '@material-ui/icons/Save';
import { NavLink as RouterLink } from 'react-router-dom';
import { OpenMode } from './openMode';
import Button from '../../common/Button';

const useStyles = makeStyles(theme => ({
  ...theme.customTheme,
  bottomBar: {
    padding: '.25rem',
    bottom: 0,
    justifyContent: 'center',
    color: theme.palette.contrastText,
    backgroundColor: theme.palette.contrastBackground,
    opacity: 0.95,
    [theme.breakpoints.up('xl2')]: {
      paddingLeft: '3.5%',
      paddingRight: '3.5%',
    },
  },
  toolbar: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      flexGrow: 0,
    },
  },
  actionButton: {
    margin: '.25rem .75rem',
  },
}));

export default function ContactFooter(props) {
  const AdapterLink = React.forwardRef((prop, ref) => <RouterLink innerRef={ref} {...prop} />);
  const { t } = useTranslation();
  const classes = useStyles();
  const { openMode, contact, onSave, onEdit, disabled, onCancel } = props;

  return (
    <AppBar component="div" position="sticky" elevation={0} className={classes.bottomBar}>
      <div className={classes.toolbar}>
        <Button
          id="cancelButton"
          color="secondary"
          className={classes.actionButton}
          onClick={onCancel}
          to={openMode === OpenMode.NEW ? '/addressbook' : `/addressbook/contact/${contact?.id || ''}`}
          component={AdapterLink}
        >
          {t('actions.cancel')}
        </Button>
        {openMode === OpenMode.NEW && (
          <Button
            id="newContactButton"
            color="primary"
            disabled={disabled}
            className={classes.actionButton}
            startIcon={<SaveIcon />}
            onClick={onSave}
          >
            {t('add.contact')}
          </Button>
        )}
        {openMode === OpenMode.EDIT && (
          <Button
            id="editContactButton"
            color="primary"
            disabled={disabled}
            className={classes.actionButton}
            startIcon={<SaveIcon />}
            onClick={onEdit}
          >
            {t('save.changes')}
          </Button>
        )}
      </div>
    </AppBar>
  );
}
